export class Periodo {

  public PeriodoId: number;
  public Periodo: string;
  public FechaInicio: Date;
  public FechaFin: Date;

  constructor() {
    this.PeriodoId = -1;
    this.Periodo = '';
  }
}
